var map = {
	"./account--avatar.svg": "423f",
	"./developers--avatar.svg": "df71",
	"./directory--avatar.svg": "42d8",
	"./documents--avatar.svg": "6983",
	"./folios--avatar.svg": "296c",
	"./notifications--avatar.svg": "0bd4",
	"./pos--avatar.svg": "303b",
	"./purchases--avatar.svg": "09db",
	"./reports--avatar.svg": "fef3",
	"./sii--avatar.svg": "7bc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46c1";